import { LocalizedText, lt, showSuccessAlert } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { DropDownButton, DropdownItem, IconName } from '@optimus-web/core';
import { copyToClipboard } from '@mews-commander/utils';
import { PortfolioCentralRateGroupOverview } from '@mews-commander/data-access';

interface Props {
    rateGroup: PortfolioCentralRateGroupOverview;
}
export const CentralRateGroupRowActions = ({ rateGroup }: Props) => (
    <DropDownButton icon={IconName.More} variant="ghost" size="small">
        <DropdownItem
            label={<LocalizedText textKey={TextKey.CopyRateGroupId} />}
            onClick={() => {
                if (copyToClipboard(rateGroup.id)) {
                    showSuccessAlert({ description: lt('CopiedSuccessMessage') });
                }
            }}
        />
    </DropDownButton>
);
